export const TARIFF_TYPES = {
    ORDER: 'Order Tariffs',
    DRIVER: 'Driver Tariffs',
};

// Non-public algos stay hidden unless the account already has an override using one, so an
// existing tariff never becomes unreadable just because its algo was retired from the picker.
export const ALGO_TYPES = {
    ORDER: [
        { value: 'WERNER_CARRIER_DEFAULT', label: 'Werner Agent', public: false },
        { value: 'ONWARD_CONSOLIDATED', label: 'Onward V2', public: true },
        { value: 'ROCKET_SHIPPING', label: 'Rocket Shipping', public: false },
        { value: 'LIVING_SPACES', label: 'Living Spaces', public: false },
        { value: 'DEFAULT', label: 'Onward V1', public: true },
    ],
    DRIVER: [
        { value: 'DRIVER_DAILY_FLAT', label: 'Base Rate', public: true },
        { value: 'DRIVER_DAILY_MILEAGE', label: 'Mileage Rate', public: true },
    ],
};

// Figma "Agreed tariffs" also draws a BASE column. There is no single base price to put in it —
// a tariff's rates are a matrix keyed by axis and quantity (see `rates`, `base_rates_axis`,
// `base_rates_qty`), so no honest scalar exists. Left out rather than faked.
export const TARIFF_COLUMNS = [
    { key: 'tariff', label: 'Tariff' },
    { key: 'kind', label: 'Kind', width: 200 },
    { key: 'status', label: 'Status', width: 140 },
    { key: 'actions', label: '', width: 220, align: 'right' },
];
